import { FC, useMemo } from 'react';

import { IMultisportCompetition, SportTypes } from '../../../../../packages/types';

import { SMPSportIcon, SMPText, SMPFlex, SMPGroupCountBadge } from '../../../../../packages/ui';
import { IMultisportEventsLabels } from '../../utils/getMultisportLabels';

interface SportsCountProps {
  sportGroup: IMultisportCompetition;
  labels: IMultisportEventsLabels;
}

export const SportsGroup: FC<SportsCountProps> = ({ sportGroup, labels }) => {
  const eventsCounts = useMemo(() => sportGroup.competitions.reduce((acc, comp) => acc + comp.eventCount, 0), [sportGroup]);

  return (
    <SMPFlex
      align='center'
      style={{
        backgroundColor: 'var(--colors-pillBackgroundColor)',
        padding: '8px',
        borderRadius: '6px',
        marginBottom: '4px',
        justifyContent: 'space-between',
      }}
    >
      <SMPFlex align='center' style={{ gap: '4px' }}>
        <SMPSportIcon sport={sportGroup.sport as SportTypes} />
        <SMPText
          style={{
            color: 'var(--colors-multiSportTextColor)',
            fontSize: '12px',
            fontWeight: '600',
            lineHeight: '20px',
          }}
        >
          {labels[sportGroup.sport as keyof IMultisportEventsLabels]}
        </SMPText>
      </SMPFlex>
      <SMPGroupCountBadge eventsCounts={eventsCounts} />
    </SMPFlex>
  );
};
